import { useEffect, useState } from "react";
import axios from "./axiosConfig";

export const useLookup = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [buyers, setBuyers] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  useEffect(() => {
    axios.get("/lookup/suppliers").then((r) => setSuppliers(r.data)).catch(() => {});
    axios.get("/lookup/buyers").then((r) => setBuyers(r.data)).catch(() => {});
    axios.get("/lookup/currencies").then((r) => setCurrencies(r.data)).catch(() => {});
  }, []);

  return { suppliers, buyers, currencies };
};
